module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-safari-permission-2b-ce52315cfb06e67cdeeccdd1c63b4d92.png";